import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { HomePageOptionsCardStyled } from '../HomePageOptionsCardStyled';

export const HomePageOptionsCardStyledAC = styled(HomePageOptionsCardStyled)`
    font-family: ${({ theme }) => theme.fonts.fontSecondary};

    @media (min-width: ${breakpoints.xs}px) {
        min-height: ${rem(365)};
    }

    &.offer-card {
        .home-optionCard--image {
            transform: scaleX(-1);
        }
    }

    .home-optionCard--image {
        max-width: ${rem(360)};
    }
`;
